import { Price } from '@spartacus/core';
import { StatusRequest } from '../../../../../core/models/request-status.model';

export enum PH_ATTRIBUTES_TYPE {
  PAYMENT_NUMBER = 'paymentNumber',
  AMOUNT = 'amount',
}

export enum PH_SEARCH_TYPE {
  EXACTLY = 'exactly',
  START_WITH = 'startWith',
}

export interface PaymentHistoryRequestConfig {
  attributesType: PH_ATTRIBUTES_TYPE;
  searchType: PH_SEARCH_TYPE;
  value?: string;
}

export interface PaymentHistoryItem {
  code?: string;
  yourPayment: string;
  receiptDate: Date;
  paymentAmount: Price;
  appliedAmount: Price;
}

export interface PaymentHistoryReportRequest extends StatusRequest {
  table?: PaymentHistoryItem[];
}

export interface PaymentHistoryDetailsRequestConfig {
  code: string;
}

export interface PaymentHistoryDetailsItem {
  invoice?: string;
  invoiceDate?: Date;
  appliedAmount?: Price;
  discountTaken?: Price;
  dateApplied?: Date;
  amountDueRemaining?: Price;
}

export interface PaymentHistoryDetailsRequest extends StatusRequest {
  table?: PaymentHistoryDetailsItem[];
}
